import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";
import PropTypes from "prop-types";
import lightColors from "assets/theme/base/colors";

const CREATE_CLIENT_VALUE = "__CREATE_CLIENT__";

const defaultFilterOptions = createFilterOptions();

function RenderFormHelper({ touched, error }) {
  if (!(touched && !!error)) {
    return <div />;
  }

  return <FormHelperText>{error}</FormHelperText>;
}

function FormClientSelector({
  input,
  label,
  values,
  names,
  meta: { touched, error },
  onCreateClient,
  ...rest
}) {
  const getName = (uid) => {
    const foundName = names.find((entry) => entry.uid === uid);

    return foundName?.name || "";
  };

  const filterOptions = (options, params) => {
    const clientOptions = options.filter((option) => option !== CREATE_CLIENT_VALUE);

    const filteredClients = defaultFilterOptions(clientOptions, {
      ...params,
      getOptionLabel: getName,
    });

    if (!options.includes(CREATE_CLIENT_VALUE)) {
      return filteredClients;
    }

    return [...filteredClients, CREATE_CLIENT_VALUE];
  };

  const handleChange = (event, value) => {
    if (value === CREATE_CLIENT_VALUE) {
      onCreateClient();
      return;
    }

    input.onChange(value);
  };

  return (
    <FormControl
      error={touched && !!error}
      style={{
        display: "flex",
        flexGrow: 1,
      }}
    >
      <Autocomplete
        {...rest}
        id={label}
        value={input.value || null}
        options={values}
        filterOptions={filterOptions}
        getOptionLabel={getName}
        isOptionEqualToValue={(option, value) => option === value}
        renderOption={(props, option) => {
          const isCreateClient = option === CREATE_CLIENT_VALUE;

          return (
            <li
              {...props}
              style={{
                ...props.style,
                textTransform: isCreateClient ? "uppercase" : undefined,
                color: isCreateClient ? lightColors.info.main : undefined,
              }}
            >
              {getName(option)}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={label}
            error={touched && !!error}
            label={label}
            variant="standard"
          />
        )}
        onChange={handleChange}
      />

      <RenderFormHelper touched={touched} error={error} />
    </FormControl>
  );
}

RenderFormHelper.defaultProps = {
  touched: false,
  error: "",
};

RenderFormHelper.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.string,
};

FormClientSelector.defaultProps = {
  label: " ",
  values: [],
  names: [],
  input: {},
  meta: {
    touched: false,
    invalid: false,
    error: "",
  },
  onCreateClient: () => {},
  style: {},
};

FormClientSelector.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  values: PropTypes.array,
  names: PropTypes.array,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.string,
  }),
  onCreateClient: PropTypes.func,
  style: PropTypes.object,
};

export default FormClientSelector;
